import React, { Component, useState, useEffect, useCallback } from "react";
import Swal from 'sweetalert2';
import { Col, Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import { api_url } from "./globalFunction/global_string";
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';

import "./Form.css";

export class FormLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: '',
      password: '',
      loggedIn: false,
      refreshReCaptcha: false,
      reCaptchaValue: ''
    };
  }

  handleReCaptcha = (value) => {
    this.setState({ reCaptchaValue: value });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  componentDidMount() {
    this.handleRefreshReCaptcha();
  }
  handleRefreshReCaptcha = () => {
    this.setState(prevState => ({ refreshReCaptcha: !prevState.refreshReCaptcha }));
  };
  handleSubmit = (e) => {
    e.preventDefault();
    let apiUrl = api_url + "/api/Auth/Login";

    const formData = new FormData();
    formData.append("User_id", this.state.account);
    formData.append("Password", this.state.password);
    formData.append("reCaptchaValue", this.state.reCaptchaValue); // 将reCaptcha令牌添加到请求中

    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // console.log(data)
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷     
        switch (arr_status[0]) {
          case "200": //將Token寫入browser
            localStorage.setItem('accessToken', arr_status[1].accessToken); //將Token寫入browser
            localStorage.setItem('refreshToken', arr_status[1].refreshToken);
            localStorage.setItem('login_state', true);
            window.location.href = '/'
            //console.log(arr_status[0])
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: "帳號或密碼錯誤"
            });
            break;
          case "401":
            Swal.fire({
              icon: 'error',
              title: '【登入資料不正確】',
              text: '帳號或密碼錯誤'
            });
            break;
          case "403":
            Swal.fire({
              icon: 'error',
              title: '【reCaptcha不正確】',
              text: arr_status[2]
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      }).finally(() => {
        this.handleRefreshReCaptcha();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} >
        <FormGroup row>
          <Label for="account" sm={2} className="text-right">帳號</Label>
          <Col lg={6} md={8} sm={10}>
            <Input type="text" name="account" placeholder="帳號" value={this.state.account} onChange={this.handleChange} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="password" sm={2} className="text-right">密碼</Label>
          <Col lg={6} md={8} sm={10}>
            <Input type="password" name="password" placeholder="密碼" value={this.state.password} onChange={this.handleChange} />
          </Col>
        </FormGroup>
        <GoogleReCaptcha
          onVerify={this.handleReCaptcha}
          refreshReCaptcha={this.state.refreshReCaptcha}
        />
        <FormGroup row>
          <Col sm={2}>
            <p>&nbsp;</p>
          </Col>
          <Col sm={{ size: 10 }}>
            <Button type="submit">登入</Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}
